module.exports = __webpack_public_path__ + "img/img_13.afddb51b.webp";